export default __webpack_public_path__ + "static/media/talkmasters logo.03a2a6f6.png";